module.exports = __webpack_public_path__ + "Simple-Line-Icons.5db2ea1bcb7a6cc07875.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons/fonts/Simple-Line-Icons.svg
// module id = ../../../../../src/assets/fonts/line-icons/fonts/Simple-Line-Icons.svg
// module chunks = styles